import { getInfo, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters';

export default function DetailsFormatter({ info }) {
  const { row } = getInfo(info)
  const { integrationDataParsed, type } = row
  const data = integrationDataParsed[TYPES_MAPPING[type]]

  let content = null

  if (['partner-twyne', 'partner-ifficient', 'partner-optintelligence'].includes(type)) {
    const { pubid, srcid, url } = data || {}
    content = [pubid && `PID: ${pubid}`, srcid && `SID: ${srcid}`, url && `TWYNE URL: ${url}`].filter(Boolean).join(' | ')
  }

  if (type.startsWith('tcpa')) {
    const { cfid_number, cfid } = data || {}
    content = (cfid_number && cfid) && `Custom Field: [#${cfid_number}] ${cfid}`
  }

  if (type === 'partner-permissiondata') {
    const { identifier } = data || {}
    content = identifier && `SCRIPT IDENTIFIER: ${identifier}`
  }

  return <>
    <TruncateWithTooltipFormatter className='twy-text-base-accent' value={type} />
    {content && <TruncateWithTooltipFormatter className='font-semibold twy-text-base-neutral' tipProps={{ side: 'bottom' }} value={content} />}
  </>
}

const TYPES_MAPPING = {
  'tcpa-question': 'tcpaquestion',
  'tcpa-linkout-question': 'linkoutquestion',
  'tcpa-call-question': 'callquestion',
  'tcpa-confirmation': 'tcpaconfirmation',
  'tcpa-form': 'tcpaform',
  'partner-twyne': 'twyne',
  'tcpa-question-custom': 'tcpaquestioncustom',
  'partner-optintelligence': 'optintelligence',
  'partner-permissiondata': 'permissiondata',
  'partner-ifficient': 'ifficient',
}
